import { render, staticRenderFns } from "./MaterialSubgroup.vue?vue&type=template&id=0c819f26&scoped=true&"
import script from "./MaterialSubgroup.vue?vue&type=script&lang=js&"
export * from "./MaterialSubgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c819f26",
  null
  
)

export default component.exports